import './globals.css';
import { PropsWithChildren } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';

import theme from '../theme';

import { ToastProvider } from './toast-provider';

export const Providers = ({ children }: PropsWithChildren) => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <ToastProvider />
    {children}
  </ThemeProvider>
);
